import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaServer, FaMapMarkedAlt, FaChartLine, FaUsers, FaTerminal, FaTachometerAlt, FaUserCog, FaFileContract } from 'react-icons/fa';

const Sidenav = ({ user, open, onClose }) => {
  const location = useLocation();
  const isAdmin = user && user.role === 1;

  const linkClass = (path) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      location.pathname === path
        ? 'bg-emerald-50 text-emerald-700'
        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
    }`;

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/50 z-[1001] md:hidden" onClick={onClose} />
      )}

      <aside className={`
        fixed top-0 left-0 z-[1002] h-screen w-64 bg-gray-900 text-white
        flex flex-col shadow-xl
        transform transition-transform duration-300 ease-in-out
        ${open ? 'translate-x-0' : '-translate-x-full'}
        md:translate-x-0 md:fixed
      `}>
        <div className="flex items-center gap-3 px-5 py-5 border-b border-gray-700">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-emerald-500/25">
            S
          </div>
          <div>
            <h1 className="font-bold text-base tracking-tight">Station</h1>
            <p className="text-[10px] text-gray-400 uppercase tracking-wider">Plataforma</p>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {user && !isAdmin && (
            <Link to="/dashboard" onClick={onClose} className={linkClass('/dashboard')}>
              <FaTachometerAlt className="w-4 h-4" />
              Dashboard
            </Link>
          )}
          {!isAdmin && (
            <>
              <Link to="/terminales" onClick={onClose} className={linkClass('/terminales')}>
                <FaServer className="w-4 h-4" />
                Mis Terminales
              </Link>
              <Link to="/mapa" onClick={onClose} className={linkClass('/mapa')}>
                <FaMapMarkedAlt className="w-4 h-4" />
                Mapa
              </Link>
              <Link to="/graficos" onClick={onClose} className={linkClass('/graficos')}>
                <FaChartLine className="w-4 h-4" />
                Gráficos
              </Link>
            </>
          )}

          {isAdmin && (
            <>
              <div className="pt-4 pb-1">
                <hr className="border-gray-700" />
              </div>
              <p className="px-4 py-1 text-[10px] text-gray-500 uppercase tracking-widest font-semibold">Administración</p>
              <Link to="/admin/clientes" onClick={onClose} className={linkClass('/admin/clientes')}>
                <FaUsers className="w-4 h-4" />
                Clientes
              </Link>
              <Link to="/admin/terminales" onClick={onClose} className={linkClass('/admin/terminales')}>
                <FaTerminal className="w-4 h-4" />
                Terminales
              </Link>
              <Link to="/admin/usuarios" onClick={onClose} className={linkClass('/admin/usuarios')}>
                <FaUserCog className="w-4 h-4" />
                Usuarios
              </Link>
              <Link to="/admin/contratos" onClick={onClose} className={linkClass('/admin/contratos')}>
                <FaFileContract className="w-4 h-4" />
                Contratos
              </Link>
            </>
          )}
        </nav>
      </aside>
    </>
  );
};

export default Sidenav;
